import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeFUTAReport extends Layout {
    checkboxIncludeSettlement: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceFUTAReports: DataSource;
    textboxDateRange: Textbox;
}
